angular.module('bribac.components.ruleSetEditor', [
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.services.api',
  'bribac.services.errorUtils',
  'bribac.validators.disableValidator',
  'bribac.components.modelMinutesAsSeconds'
])

  .component('ruleSetEditor', {
    templateUrl: 'rule-set-editor-component.html',
    controller: 'RuleSetEditorComponentCtrl',
    bindings: {
      ruleSet: '<',
      // If `templateOption` is true the "Save a template copy" checkbox will be
      // shown.
      templateOption: '<',
      // If `saveToApi` is true the rule-set will be PUT/POSTed to the API when
      // saving, if it's false the rule-set will be passed directly to the
      // success callback instead.
      saveToApi: '<',
      successCallback: '<',
      cancelCallback: '<',
      organizationCanBeSpecified: '<'
    }
  })

  .controller('RuleSetEditorComponentCtrl', function(
    api,
    KINDS,
    TEXT_EXPIRATION_INTERVAL_REGEX,
    errorUtils,
    permissions
  ) {
    var $ctrl = this
    $ctrl.permissions = permissions

    $ctrl.TEXT_EXPIRATION_INTERVAL_REGEX = TEXT_EXPIRATION_INTERVAL_REGEX

    $ctrl.notifyMonitorOptions = [
      {prop: 'notifyPassed', i18n: 'testPassed'},
      {prop: 'notifyFailed', i18n: 'testFailed'},
      {prop: 'notifyPassedOptional', i18n: 'optionalTestPassed'},
      {prop: 'notifyFailedOptional', i18n: 'optionalTestFailed'},
      {prop: 'notifyExpired', i18n: 'testExpired'},
      {prop: 'notifyFrs', i18n: 'frs'},
    ]

    $ctrl.notifySubjectOptions = [
      {prop: 'notifySubjectBySms', i18n: 'sms'},
      {prop: 'notifySubjectByMail', i18n: 'email'},
      {prop: 'notifySubjectByPush', i18n: 'push'},
    ]

    function resetForm() {
      if ($ctrl.form) {
        $ctrl.form.$setUntouched()
        $ctrl.form.$setPristine()
      }
    }

    function submitSuccess(request) {
      $ctrl.form._submitSuccess = 'Saved ' + request.data.name
      resetForm()
      $ctrl.successCallback(request.data)
    }

    $ctrl.onSubmit = function() {
      var $form = $ctrl.form

      if ($form._submitting) return
      if ($form.$invalid) {
        $form._submitError = 'formErrors.invalidFields'
        return
      }

      $form._submitSuccess = ''
      $form._submitError = ''

      if ($ctrl.saveToApi) {
        $form._submitting = true

        api[$ctrl.editableRuleSet.id ? 'put' : 'post'](KINDS.RULE_SET, $ctrl.editableRuleSet)
          .finally(function() { $form._submitting = false })
          .then(submitSuccess, function error(request) {
            $form._submitError = errorUtils.parseErrorResponse(request)
          })
      } else {
        submitSuccess({data: $ctrl.editableRuleSet})
      }
    }

    $ctrl.$onInit = function() {
      $ctrl.minBacLimitValue = 0.0
      switch (this.dataUnit){
         case 'BAC_PERCENT':
              $ctrl.maxBacLimitValue = 69.05
             break;

         case 'BAC_PER_MILLE':
              $ctrl.maxBacLimitValue = 6.9
             break;

         case 'BRAC':
              $ctrl.maxBacLimitValue = 14.5
             break;

         default:
             console.log('Unknown or undefined bac limit unit')
      }
    }

    $ctrl.$onChanges = function(changes) {
      if (changes.ruleSet) {
        // Reset state since the rule-set instance we're editing has changed.
        resetForm()
        $ctrl.editableRuleSet = angular.copy($ctrl.ruleSet)
        this.dataUnit = $ctrl.editableRuleSet.bacLimit.unit
      }
    }

  })
